import query from './APIServices'

export interface Product {
  id: number
  name: string
  type: string
  salesCode: string
  showForSale: boolean
  stockLimit: boolean
  totalQuantity: string
  barCode: string
  qrCode: string
  measure: string
  alertLimit: string
  isAlertable: boolean
  isUnderAlertLimit: boolean
  isPublicVisible: boolean
  averageCost: string
  productCategoryId: number
  salesCategoryId: number
  createdAt: string
  supplierId: number
  groupName: string
  description: string
  groupConvertion: number
  enableGroup: boolean
  isWholesale: boolean
  visibleOnline: boolean
  availableForReservation: boolean
  alwaysAvailableForReservation: boolean
  reservationAvailableFrom: string
  reservationAvailableTo: string
  duration: string
  hasDuration: boolean
  onSale: boolean
  onSaleType: string
  onSaleDiscountAmount: string
  elaborationSteps: string
  netCost: string
  productCategory: string
  salesCategory: SalesCategory
  fixedCosts: string[]
  onSalePrice: string
  images: string[]
  resources: string[]
  prices: Price[]
  supplies: string[]
  attributes: string[]
}

export interface SalesCategory {
  id: number
  name: string
  description: string
  color: string
}

export interface Price {
  price: number
  isMain: boolean
  codeCurrency: string
  priceSystemId: number
}

export interface ProductsParams {
  page: number
  per_page: number
  search: string
  type?: string | string[]
}

export interface ProductsPostParams {
  name: string
  type: string
  prices: [{ price: number; codeCurrency: string }]
  salesCategoryId?: number
}

export const getProducts = async (params: ProductsParams) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const response = await query.get('/administration/product/finder', {
    params: cleanParams,
  })
  // El nuevo endpoint podría devolver los datos directamente en response.data
  // en lugar de response.data.items
  return (response?.data.items || response?.data) as Product[]
}

export const getProduct = async (id: number) => {
  const response = await query.get(`/administration/product/${id}`)
  return response?.data as Product
}

export const postProducts = async (params: ProductsPostParams) =>
  await query.post('/administration/product', params)
